/**
 * Widevine Key System.
 *
 *
 * @beta
 */
export const WIDEVINE_KEY_SYSTEM = 'com.widevine.alpha'
